import { SolvTheme } from './theme';

export type Tone =
  | 'warning'
  | 'critical'
  | 'info'
  | 'message'
  | 'success'
  | 'promote';

export const tones: Record<
  Tone,
  {
    text: keyof typeof SolvTheme.colors;
    background: keyof typeof SolvTheme.colors;
    muted: keyof typeof SolvTheme.colors;
    border?: string;
  }
> = {
  warning: {
    text: 'peach-dark',
    background: 'peach-light',
    muted: 'peach',
  },
  critical: {
    text: 'cherry-dark',
    background: 'cherry-light',
    muted: 'cherry',
  },
  success: {
    text: 'mint-dark',
    background: 'mint-light',
    muted: 'mint',
  },
  info: {
    text: 'gray-600',
    background: 'karl',
    muted: 'gray-500',
  },
  message: {
    text: 'gray-600',
    background: 'egg',
    muted: 'gray-500',
    border: `1px solid ${SolvTheme.colors['gray-200']}`,
  },
  promote: {
    text: 'grape-dark',
    background: 'grape-xlight',
    muted: 'grape',
  },
};
